import axios from "@/plugins/modules/axios";

export default {
  namespaced: true,
  state: {
    user_info: {
      name: "",
      max_role_level: 0,
      permissions: [],
      roles: []
    }
  },
  mutations: {
    setUserInfo(state, payload) {
      state.user_info = payload;
    },
    setName(state, payload) {
      state.user_info.name = payload;
    },
    setPermissions(state, payload) {
      state.user_info.permissions = payload;
    },
    setMaxRoleLevel(state, payload) {
      state.user_info.max_role_level = payload;
    },
    setRoles(state, payload) {
      state.user_info.roles = payload;
    }
  },
  actions: {
    fetchPermissions({commit}) {
      return axios.post(`/me`).then(res=>{
        let response = res.data.response;
        commit("setName", response.name);
        commit("setPermissions", response.privileges);
        commit("setMaxRoleLevel", response.max_role_level);
        commit("setRoles", response.role);
        return true;
      }).catch(err=>{
        // localStorage.removeItem("lt");
        axios.defaults.headers.common["Authorization"] = "";
        // location.href = "/";
        return false;
      });
    }
  }
}